import type { ClientInfoRow } from './config';

/** Bản chụp các cột lịch của tblClientInfo HANA (LOGI-data-dictionary.md, 28/Oct/2026) — để chạy dữ liệu mẫu
 *  và kiểm. App thật đọc dòng tblClientInfo qua worker `api` rồi gọi configFromClientInfo.
 *  Ngày lễ ở đây là mẫu: chỉ có các dòng tài liệu ghi; danh sách đủ lấy từ DB. */
export const HANA_CLIENT_INFO: ClientInfoRow = {
  WorkDays: '2,3,4,5,6,7',
  WorkMorningStart: '08:00',
  WorkMorningEnd: '11:45',
  WorkAfternoonStart: '13:15',
  WorkAfternoonEnd: '17:30',
  WorkSatEnd: '12:00',
  AnnualLeaveDays: 12,
  Holidays: '2025-01-29..2025-02-02 Tết Nguyên Đán',
  WorkdayOverrides: ['2026-01-10 Ngày làm việc (Tết Nguyên Đán)', '2026-08-22 Ngày làm việc'].join('\n'),
};
